// Community Spotlight / In The Community Data
export const communityData = {
  title: "In The Community",
  subtitle: "Explore our community activities, events, and initiatives that strengthen the early childhood education ecosystem across Washington, DC.",

  events: [
    // Archived (Sept 2026): HealthCare4ChildCare (HC4CC) card removed from public site per user request.
    {
      id: 2,
      title: "Faith UCC Mobile Market",
      description: "Free fresh produce, bread, pastries, and diapers for babies and adults. Bring your bags and invite family, friends, and neighbors!",
      category: "Community",
      date: "3rd Thursday Monthly",
      location: "4900 10th St NE, Washington, DC 20017",
      image: "https://customer-assets.emergentagent.com/job_548e8c1f-8aee-47f4-a78f-1f6376525bd5/artifacts/hj0febw4_unnamed%20%282%29.png",
      link: "/initiatives/faith-ucc-mobile-market"
    },
    {
      id: 3,
      title: "DC Men in ECE 4th Annual Citywide Conference",
      description: "Brotherhood, Belonging, and Brilliance: Redefining Men in ECE. A powerful gathering of educators, leaders, and changemakers committed to elevating the voice, impact, and presence of men in early childhood education. Keynote, workshops, panels, and networking.",
      category: "Event",
      date: "October 12, 2026",
      location: "Aspen Institute, Washington, DC NW",
      image: "https://customer-assets-cm19k8pv.emergentagent.net/job_55671c95-2135-4572-a38e-4ba882651c43/artifacts/vikxaxtm_lnm61u0y_2026%20Save%20the%20Date%20Flyer.jpg",
      imageEs: "https://customer-assets-cm19k8pv.emergentagent.net/job_55671c95-2135-4572-a38e-4ba882651c43/artifacts/gvf0nurj_4.png",
      link: "https://dcmeninece.org/conference"
    },
    {
      id: 5,
      title: "NAEYC 2026 Annual Conference",
      description: "The nation's largest early childhood education conference comes to Washington, DC! Join tens of thousands of educators, directors, and advocates for four days of professional learning, research-based sessions, and networking — right in our own backyard.",
      category: "Event",
      date: "December 5–8, 2026",
      location: "Washington, DC",
      image: "https://static.prod-images.emergentagent.com/jobs/55671c95-2135-4572-a38e-4ba882651c43/images/4d019fc6e37ac54b0c01313d2adeeb197fcef463b0bf2d5fd638c484fb53b8b2.jpeg",
      link: "https://www.naeyc.org/events/annual/registration"
    },
    {
      id: 6,
      title: "Under 3 DC: Mayoral Transition Memo",
      description: "The Under 3 DC Coalition's September 2026 transition memo lays out the early childhood priorities DC's next mayor must champion — from protecting child care subsidies and educator pay equity to strengthening infant and toddler systems. Read it and share it with your network.",
      category: "Advocacy",
      date: "September 2026",
      location: "Washington, DC",
      image: "/memos/memo-cover.jpg",
      pdf: "/memos/under-3-dc-mayoral-transition-memo-sept-2026.pdf"
    }
  ]
};
